export const ENDPOINT = {
  "/as": {
    "/authorization.oauth2": "/as/authorization.oauth2",
    "/token.oauth2": "/as/token.oauth2",
  },
  "/auth": {
    "/token-exchange": "/v1/auth/token-exchange",
    "/refresh-tokens": "/v1/auth/refresh-tokens",
    "/direct-token": "/v1/auth/direct-token",
  },
  "/access": {
    "/permissions": "/v1/access/permissions",
    "/roles": "/v1/access/roles",
    "/roles/permissions": "/v1/access/roles/permissions",
  },
  "/master": {
    "/week": "/v1/master/week",
    "/contract-type": "/v1/master/contract-type",
    "/week-off": "/v1/master/week-off",
    "/work-hours": "/v1/master/work-hours",
    "/leave-policy": "/v1/master/leave-policy",
    "/country": "/v1/master/country",
    "/state": "/v1/master/state",
    "/city": "/v1/master/city",
    "/holiday": "/v1/master/holiday",
    "/sport": "/v1/master/sport",
    "/cost-centre": "/v1/master/cost-centre",
    "/leave": "/v1/master/leave",
    "/menstrual-leave-config": "/v1/master/menstrual-leave-config",
  },
  "/user": {
    "": "/v1/user",
    "/cost-centre": "/v1/user/cost-centre",
    "/reg-token": "/v1/user/reg-token",
    "/fcm-token": "/v1/user/fcm-token",
  },
  "/leave": {
    "/my-leaves": "/v1/leave/my-leaves",
    "/apply": "/v1/leave/apply",
    "/cancel": "/v1/leave/cancel",
    "/my-team-leaves": "/v1/leave/my-team-leaves",
  },
  "/cluster": {
    "": "/v1/cluster",
    "/employees": "/v1/cluster/employees",
    "/remove-user": "/v1/cluster/remove-user",
    "/info": "/v1/cluster/info",
  },
  "/week-off": {
    "/apply": "/v1/week-off/apply",
    "/emp": "/v1/week-off/emp",
  },
  "/secondary": {
    "/master-config": "/v1/secondary/master-config",
    "/store-config": "/v1/secondary/store-config",
    "/add-store-config": "/v1/secondary/add-store-config",
    "/remove-store-config": "/v1/secondary/remove-store-config",
    "/update-members": "/v1/secondary/update-members",
    "/members": "/v1/secondary/members",
  },
  "/shift": {
    "": "/v1/shift",
  },
  "/roster": {
    "/day-work": "/v1/roster/day-work",
    "/secondary": {
      "": "/v1/roster/secondary",
      "/init": "/v1/roster/secondary/init",
      "/save": "/v1/roster/secondary/save",
      "/publish": "/v1/roster/secondary/publish",
      "/monthSummary": "/v1/roster/secondary/monthSummary",
    },
    "/primary": {
      "": "/v1/roster/primary",
      "/init": "/v1/roster/primary/init",
      "/save": "/v1/roster/primary/save",
      "/publish": "/v1/roster/primary/publish",
      "/monthSummary": "/v1/roster/primary/monthSummary",
      "/miscWork": "/v1/roster/primary/miscWork",
    },
  },
  "/migration": {
    "": "/v1/migration",
    "/status": "/v1/migration/status",
  },
  "/integration-job": {
    "": "/v1/integration-job",
    "/status": "/v1/integration-job/status",
    "/error": "/v1/integration-job/error",
  },
  "/slave": {
    "/status": "/v1/slave/migration/status",
    "/refresh-leaves": "/v1/slave/migration/refresh-leaves",
  },
  "/hours": {
    "/manual": "/v1/hours/manual",
    "/emp": "/v1/hours/emp",
    "/my-work-hours": "/v1/hours/my-work-hours",
    "/my-team-hours": "/v1/hours/my-team-hours",
    "/payroll-config": "/v1/hours/payroll-config",
    "/payroll-data": "/v1/hours/payroll-data",
    "/approve": "/v1/hours/approve",
    "/validate": "/v1/hours/validate",
    "/emp-calender-hours": "/v1/hours/emp-calender-hours",
    "/my-team-info": "/v1/hours/my-team-info",
  },
  "/shift-swap": {
    "": "/v1/shift-swap",
    "/approve": "/v1/shift-swap/approve",
    "/reject": "/v1/shift-swap/reject",
    "/delete": "/v1/shift-swap/delete",
  },
  "/analytics": {
    "/hrs-dist-combined": "/v1/analytics/hrs-dist-combined",
    "/hrs-dist-category": "/v1/analytics/hrs-dist-category",
    "/hrs-dist-work-type": "/v1/analytics/hrs-dist-work-type",
    "/hrs-dist-wow": "/v1/analytics/hrs-dist-wow",
    "/hrs-dist-mom": "/v1/analytics/hrs-dist-mom",
    "/hrs-dist-qoq": "/v1/analytics/hrs-dist-qoq",
    "/manual-hr-contribution": "/v1/analytics/manual-hr-contribution",
    "/manual-hr-contrib-dist": "/v1/analytics/manual-hr-contrib-dist",
    "/manual-hr-contrib-mom": "/v1/analytics/manual-hr-contrib-mom",
    "/eff-combined": "/v1/analytics/eff-combined",
    "/eff-dist": "/v1/analytics/eff-dist",
    "/eff-wow": "/v1/analytics/eff-wow",
    "/eff-mom": "/v1/analytics/eff-mom",
    "/eff-qoq": "/v1/analytics/eff-qoq",
    "/hrs-combined": "/v1/analytics/hrs-combined",
    "/hrs-dist-work": "/v1/analytics/hrs-dist-work",
    "/pt-ft-hrs-combined": "/v1/analytics/pt-ft-hrs-combined",
    "/pt-ft-dist-hrs": "/v1/analytics/pt-ft-dist-hrs",
    "/wd-nwd-hrs-combined": "/v1/analytics/wd-nwd-hrs-combined",
    "/wd-nwd-dist-hrs-combined": "/v1/analytics/wd-nwd-dist-hrs-combined",
    "/pk-npk-hrs-combined": "/v1/analytics/pk-npk-hrs-combined",
    "/pk-npk-dist-hrs-combined": "/v1/analytics/pk-npk-dist-hrs-combined",
    "/total-hrs-dist-wow": "/v1/analytics/total-hrs-dist-wow",
    "/total-hrs-dist-mom": "/v1/analytics/total-hrs-dist-mom",
    "/total-hrs-dist-qoq": "/v1/analytics/total-hrs-dist-qoq",
    "/pt-ft-hrs-dist-wow": "/v1/analytics/pt-ft-hrs-dist-wow",
    "/pt-ft-hrs-dist-mom": "/v1/analytics/pt-ft-hrs-dist-mom",
    "/pt-ft-hrs-dist-qoq": "/v1/analytics/pt-ft-hrs-dist-qoq",
    "/wd-nwd-hrs-dist-wow": "/v1/analytics/wd-nwd-hrs-dist-wow",
    "/wd-nwd-hrs-dist-mom": "/v1/analytics/wd-nwd-hrs-dist-mom",
    "/wd-nwd-hrs-dist-qoq": "/v1/analytics/wd-nwd-hrs-dist-qoq",
    "/pk-npk-hrs-dist-wow": "/v1/analytics/pk-npk-hrs-dist-wow",
    "/pk-npk-hrs-dist-mom": "/v1/analytics/pk-npk-hrs-dist-mom",
    "/pk-npk-hrs-dist-qoq": "/v1/analytics/pk-npk-hrs-dist-qoq",
    "/affinity-calender-view": "/v1/analytics/affinity-calender-view",
    "/affinity-hrs-total": "/v1/analytics/affinity-hrs-total",
    "/affinity-hrs-dist-work": "/v1/analytics/affinity-hrs-dist-work",
    "/affinity-hrs-dist-wow": "/v1/analytics/affinity-hrs-dist-wow",
    "/affinity-hrs-dist-mom": "/v1/analytics/affinity-hrs-dist-mom",
    "/affinity-hrs-dist-qoq": "/v1/analytics/affinity-hrs-dist-qoq",
    "/eco-mobility/combined": "/v1/analytics/eco-mobility/combined",
    "/eco-mobility/distributed/eco-non-eco-distance":
      "/v1/analytics/eco-mobility/distributed/eco-non-eco-distance",
    "/eco-mobility/eco-share-wow": "/v1/analytics/eco-mobility/eco-share-wow",
    "/eco-mobility/eco-share-mom": "/v1/analytics/eco-mobility/eco-share-mom",
    "/eco-mobility/eco-share-qoq": "/v1/analytics/eco-mobility/eco-share-qoq",
    "/eco-mobility/cost-centre-wise-data-extraction":
      "/v1/analytics/eco-mobility/cost-centre-wise-data-extraction",
  },
  "/cluster-planned-jobs": {
    "/": "/v1/cluster-planned-jobs",
    "/store": "/v1/cluster-planned-jobs/store",
    "/store/disable": "/v1/cluster-planned-jobs/store/disable",
  },
  "/planned-job-week": {
    "/init": "/v1/planned-job-week/init",

    "/publish": "/v1/planned-job-week/publish",
    "/roster": "/v1/planned-job-week/roster",
    "/week-status": "/v1/planned-job-week/week-status",
  },
  "/planned-job-shift": {
    "/save": "/v1/planned-job-shift/save",
  },
  "/peak-hours": {
    "": "/v1/peak-hours",
  },
  "/effi": {
    "/migration": "/v1/effi/migration",
    "/migration/status": "/v1/effi/migration/status",
  },
  "/recommended-hours": {
    "": "/v1/recommended-hours",
  },
  "/eco-mobility": {
    "": "/v1/eco-mobility",
  },
};
